export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑设置',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ settingStatus }) => !['Y'].includes(settingStatus),
  },
  {
    text: that.$l('menu_text_delete') || '删除设置',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ settingStatus }) => !['Y'].includes(settingStatus),
  },
]
